module.exports = __webpack_public_path__ + "static/media/pin-chat.466e128b.svg";